export default function loadScript (document, moduleHTML, appEventEmitter) {
  const dataAttribute = moduleHTML.dataset.jsLoadScript
  const [eventType, scriptSrc] = dataAttribute.split('|')

  if (!eventType || !scriptSrc) {
    console.error('Missing event type or script src for element:', moduleHTML)
    console.error('Data attribute must be formatted as "eventType|scriptSrc"')
  }

  function createScript (event) {
    // Remove this event handler as it only needs called once
    moduleHTML.removeEventListener(eventType, createScript)

    const isScriptPresent = document.querySelectorAll(`script[src="${scriptSrc}"]`).length
    if (isScriptPresent) return // This script has already been loaded by anothe element, don't add it again

    const script = document.createElement('script')
    script.setAttribute('async', true)
    script.setAttribute('src', scriptSrc)
    document.body.appendChild(script)
  }

  moduleHTML.addEventListener(eventType, createScript)
}
